import Request from '../utils/request'

export function getHospitalByNameApi (params) {
  return Request({
    url: '/follow/doctorHospital/getByName',
    method: 'get',
    params
  })
}

export function getFollowArticleListApi (params) {
  return Request({
    url: '/follow/article/list',
    method: 'get',
    params
  })
}

export function getFollowArticlePageApi (params) {
  return Request({
    url: '/follow/article/page',
    method: 'get',
    params
  })
}
